module.exports = __webpack_public_path__ + "static/media/EX_FINISHED_alt_2.1ea5f9de.mp3";